import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import styles from './ReportEventSuccess.module.scss';

export const ReportEventSuccess = () => {
    return (
        <div data-testid="report-success-content">
            <p className={styles.successMessage}>
                {gettext(
                    'We have flagged this event for investigation. If you provided contact information, we may follow up with you as needed.',
                )}
            </p>
        </div>
    );
};
